'use client';

import { useEffect } from 'react';

import { useTranslations } from 'next-intl';

import { MFA_ENABLED_KEY } from '@/modules/mfa/constants';
import { useMFATracking } from '@/modules/mfa/useMFATracking';
import {
  getSessionStorageItem,
  removeSessionStorageItem,
} from '@/modules/storage';
import { TOAST_STATUS } from '@/modules/toast/types';
import { useToast } from '@/modules/toast/useToast';

export function MfaEnabledToast() {
  const { open } = useToast();
  const t = useTranslations('common');
  const { sendMfaSetupCompletionView } = useMFATracking();

  useEffect(() => {
    const mfaEnabled = getSessionStorageItem(MFA_ENABLED_KEY);

    if (mfaEnabled === '1') {
      open({
        title: t('MFA.Toast.Enabled'),
        status: TOAST_STATUS.SUCCESS,
      });

      sendMfaSetupCompletionView();

      removeSessionStorageItem(MFA_ENABLED_KEY);
    }
  }, []);

  return null;
}
